import { isAuthenticated } from "@biggeo/bg-common";
import {
    DiscordIntegrationCard,
    FlexScrollArea,
    FlexScrollAreaContainer,
    NavigationRailCell,
    PortalMenu,
    Stack,
    Typography,
} from "@biggeo/bg-ui/lab";
import {
    ActionKeyOutline,
    DatabaseOutline,
    HomeOutline,
    PublicOutline,
    SettingsOutline,
    SupportOutline,
} from "@biggeo/bg-ui/lab/icons";
import { Link, useLocation } from "react-router-dom";

import { BigGeoLink } from "../common/components/BigGeoLink";
import { getDomain } from "../config/env.config";
import { Routes } from "../navigation/redux/model";
import { useAuthenticatedUser } from "../user/redux/hooks";

export const Sidebar = () => {
    const user = useAuthenticatedUser();

    const path = useLocation().pathname;
    const routes = path.split("/");

    const checkSelectedRoute = (route: string) =>
        routes.indexOf(route.replace("/", "")) === 1;

    const domain = getDomain();
    return (
        <FlexScrollAreaContainer>
            <FlexScrollArea
                sx={{
                    flexDirection: "column",
                    gap: 2,
                    paddingX: 3,
                    paddingTop: 4,
                    backgroundColor: (theme) => theme.palette.background.main,
                    borderRadius: (theme) => theme.radius.default,
                }}
            >
                {isAuthenticated(user) ? (
                    <PortalMenu
                        user={user}
                        currentPortal="datascape"
                        LinkComponent={BigGeoLink}
                        domain={domain}
                    />
                ) : null}
                <Stack>
                    <Link to={Routes.home} tabIndex={-1}>
                        <NavigationRailCell
                            startNode={<HomeOutline size="xs" />}
                            selected={path === Routes.home}
                        >
                            Home
                        </NavigationRailCell>
                    </Link>
                    <Link to={Routes.exploreMapView} tabIndex={-1}>
                        <NavigationRailCell
                            startNode={<ActionKeyOutline size="xs" />}
                            selected={checkSelectedRoute(Routes.explore)}
                        >
                            Explore
                        </NavigationRailCell>
                    </Link>
                </Stack>
                <Typography
                    variant="body4"
                    fontWeight="semibold"
                    textColor="disabled.onContainer"
                    sx={{
                        paddingLeft: 2,
                        cursor: "default",
                    }}
                >
                    Datascape
                </Typography>
                <Stack>
                    <Link to={Routes.mapTemplates} tabIndex={-1}>
                        <NavigationRailCell
                            startNode={<PublicOutline size="xs" />}
                            selected={checkSelectedRoute(Routes.mapTemplates)}
                        >
                            Map Templates
                        </NavigationRailCell>
                    </Link>
                    <Link to={Routes.myData} tabIndex={-1}>
                        <NavigationRailCell
                            startNode={<DatabaseOutline size="xs" />}
                            selected={checkSelectedRoute(Routes.availableData)}
                        >
                            Data Management
                        </NavigationRailCell>
                    </Link>
                    {/* <Link to={Routes.accessKeys} tabIndex={-1}>
                        <NavigationRailCell
                            startNode={<KeyOutline size="xs" />}
                            selected={checkSelectedRoute(Routes.accessKeys)}
                        >
                            Data Access
                        </NavigationRailCell>
                    </Link> */}
                    {/* <Link to={Routes.recipes}>
                            <NavigationRailCell
                                startNode={<ExperimentOutline size="xs" />}
                                selected={startsWith(path, Routes.recipes)}
                                onClick={onItemClick}
                            >
                                Recipes
                            </NavigationRailCell>
                        </Link> */}
                    {/* <Link to={Routes.team}>
                            <NavigationRailCell
                                startNode={<GroupsOutline size="xs" />}
                                selected={path === Routes.team}
                                onClick={onItemClick}
                            >
                                Team
                            </NavigationRailCell>
                        </Link> */}
                </Stack>
                <Typography
                    variant="body4"
                    fontWeight="semibold"
                    textColor="disabled.onContainer"
                    sx={{
                        paddingLeft: 2,
                        cursor: "default",
                    }}
                >
                    Space
                </Typography>
                <Stack>
                    <Link to={Routes.profileSettings} tabIndex={-1}>
                        <NavigationRailCell
                            startNode={<SettingsOutline size="xs" />}
                            selected={checkSelectedRoute(Routes.settings)}
                        >
                            Settings
                        </NavigationRailCell>
                    </Link>
                </Stack>
            </FlexScrollArea>
            <Stack
                gap={2}
                sx={{
                    padding: 3,
                }}
            >
                <Link to={Routes.gitbookSupport} target="_blank" tabIndex={-1}>
                    <NavigationRailCell
                        startNode={<SupportOutline size="xs" />}
                    >
                        Help Center
                    </NavigationRailCell>
                </Link>
                <Link to={Routes.joinBigGeoDiscord} target="_blank">
                    <DiscordIntegrationCard />
                </Link>
            </Stack>
        </FlexScrollAreaContainer>
    );
};
